import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  hostReferenceData: {},
  tenantReferenceData: {},
  productListTable: [],
  invoiceSettings: {},
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
